import styled from 'styled-components';

const AlertSystemContainer = styled.div`
  width: 300px;
  max-width: calc(100vw - 32px);
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
`;

export default AlertSystemContainer;
